// Deadlines use server time, so a wrong client clock cannot extend the session.
export const sessionDeadlines = (snapshot, receivedAt = Date.now()) => ({
  idle: receivedAt + (snapshot.idle_expires_at - snapshot.server_now) * 1000,
  absolute: receivedAt + (snapshot.absolute_expires_at - snapshot.server_now) * 1000,
  expires: receivedAt + (snapshot.expires_at - snapshot.server_now) * 1000,
  warning: snapshot.warning_seconds * 1000,
});
export const sessionPhase = (deadlines, now = Date.now()) => {
  if (!deadlines) return 'checking';
  if (now >= deadlines.expires) return 'expired';
  return now >= deadlines.expires - deadlines.warning ? 'warning' : 'active';
};
